/* istanbul ignore file */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import React, { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { Box, Spinner } from '@chakra-ui/core';
import isNumber from 'lodash/isNumber';
import InfiniteLoader from 'react-window-infinite-loader';
import { FixedSizeList } from 'react-window';
import isNil from 'lodash/isNil';
import { useLocation, useParams } from 'react-router';
import { useStoreActions, useStoreState } from '../../../../models/hooks';
import { NodeType } from './treeGroup';
import { useMessagingViewContext } from '../../MessagingViewContext';
import { Candidate, EngagedCandidate } from '../../../../firebase/firestore/documents/candidate';
import { MESSAGING_TABS_NEW, POSITION_CANDIDATE_TABS } from '../../../../routes/constants';
import { SeekerContainerTabItems } from '../../seeker/SeekerContainerContext';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { CandidateSearchResponse } from '../../../../controllers/candidateController';
import SeekerListSortType from '../filters/seekerListSortType';
import NewCandidateItem from './candidateItem/NewCandidateItem';
import { SeekersPresenter } from './seekersPresenter';
import { RemoteConfigKey } from '../../../../firebase/remoteConfig';
import { isPositionCandidatesPage } from '../../../../utils/candidatesUtils';
import useCandidate from '../../../../app/components/useCandidate';
import { useCurrentUserProfile } from '../../../../app/hooks/useCurrentUserProfile';

type Props = Record<string, unknown>;

type ToggleIconProp = {
  on: boolean;
};

const PAGE_LIMIT = 20;

const ItemRow: React.FC<{
  index: number;
  style: React.CSSProperties;
  data: {
    treeCandidates: any[];
    isFetching: boolean;
    selectedCallback: (candidate?: Readonly<EngagedCandidate>) => void;
    allSeekerList: SeekersPresenter | undefined;
    isShowFavoriteStatusEnabled: boolean;
  };
}> = React.memo(({ index, style, data }) => {
  const { treeCandidates, isFetching, selectedCallback, allSeekerList, isShowFavoriteStatusEnabled } = data;
  // eslint-disable-next-line
  const item = treeCandidates[index];
  const hasItem = Boolean(item);
  const isLoading = isFetching && !hasItem;

  return (
    <div style={style} className="item-row">
      {isLoading && (
        <Box marginY="auto" width="100%" textAlign="center">
          <Spinner color="#1F3CBA" data-testid="Spinner" />
        </Box>
      )}
      {hasItem && (
        <NewCandidateItem
          key={/* eslint-disable-next-line */ item?.candidate?.id}
          selectedCallback={selectedCallback}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          item={item as any}
          seekerList={allSeekerList}
          isShowFavoriteStatusEnabled={isShowFavoriteStatusEnabled}
        />
      )}
    </div>
  );
});

ItemRow.displayName = 'ItemRow';

const NewSeekerList: React.FC = () => {
  const {
    setSelectedEngagedCandidate,
    setSelectedEngagedSeeker,
    setSelectedCandidateId,
    selectedCandidateId,
  } = useMessagingViewContext();
  const { positionId } = useParams<{ positionId: string }>();

  const location = useLocation();
  const candidateIdFromParams = location.state?.selectedCandidateId;

  const fetchedCandidate = useCandidate(candidateIdFromParams);
  const selectedCandidate = fetchedCandidate?.candidate;

  const { searchQuery, searchAndSortTypes, sort, listType } = useSeekersFilters();
  const accountId = useStoreState((s) => s.app.user?.account);

  const searchCandidates = useStoreActions((a) => a.candidate.searchCandidates);
  const resetPaginatedCandidates = useStoreActions((a) => a.candidate.resetPaginatedCandidates);

  const paginatedCandidates = useStoreState((state) => state.candidate.paginatedCandidates);
  const allSeekerList: SeekersPresenter | undefined = useStoreState((s) => s.candidate.allCandidates);

  const isShowFavoriteStatusEnabled: boolean = useStoreState((state) => {
    return state.remoteConfig[RemoteConfigKey.SHOW_FAVORITE_STATUS];
  });

  const scrollableDivRef = React.useRef<HTMLDivElement>(null);
  const { currentUserProfile } = useCurrentUserProfile();

  const candidates = Array.from(paginatedCandidates.data.values());

  const [candidatePresenterArray, setCandidatePresenterArray] = useState<
    {
      key: string;
      label: string;
      type: NodeType;
      candidate: Candidate;
    }[]
  >([]);
  React.useEffect(() => {
    return () => {
      resetPaginatedCandidates({ resetFetching: true });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedCallback = useCallback(
    (candidate?: Readonly<EngagedCandidate>) => {
      if (candidate) {
        const redirectionFunction = isPositionCandidatesPage() ? POSITION_CANDIDATE_TABS : MESSAGING_TABS_NEW;
        setSelectedCandidateId(candidate.id);
        setSelectedEngagedSeeker({ seekerId: candidate.seeker, candidateId: candidate.id });
        window.history.pushState(
          null,
          '',
          redirectionFunction(isPositionCandidatesPage() ? positionId : candidate.id, SeekerContainerTabItems.Messaging),
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setSelectedEngagedCandidate, setSelectedEngagedSeeker],
  );

  React.useEffect(() => {
    return () => {
      resetPaginatedCandidates({ resetFetching: true });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [seekerMap, setSeekerMap] = useState<Map<string, boolean>>(new Map());
  const [listHeight, setListHeight] = useState<number>(0);

  const candidateSetter = () => {
    if (currentUserProfile && (selectedCandidate as EngagedCandidate)) {
      selectedCallback(selectedCandidate as EngagedCandidate);
    }
  };

  useEffect(() => {
    if (!isNil(selectedCandidate) && !paginatedCandidates.isFetching) {
      candidateSetter();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCandidate, paginatedCandidates.isFetching]);

  useEffect(() => {
    // let paginatedCandidateLength = 0;
    setCandidatePresenterArray([]);
    setSeekerMap(new Map());
    resetPaginatedCandidates({ resetFetching: false });

    const firstPage = 0;

    const debouncedGetCandidates = debounce(async (prevPage?: number) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      await searchCandidates({
        accountId: accountId!,
        filters: {
          listType,
          limit: PAGE_LIMIT,
          page: (isNumber(prevPage) ? prevPage : paginatedCandidates.page) + 1,
          searchQuery: searchQuery || '',
          sortBy: sort === SeekerListSortType.ALPHABETICAL ? 'name' : 'createdAt',
          sortOrder: 'asc',
          advancedFilters: searchAndSortTypes,
        },
        ...(isPositionCandidatesPage() ? { positionId } : {}),
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      }).then((data: CandidateSearchResponse) => {
        // paginatedCandidateLength += data.data.length;
        // const hasNext = data.page * PAGE_LIMIT < data.total;
        // if (hasNext && paginatedCandidateLength < PAGE_LIMIT) {
        //   debouncedGetCandidates(data.page);
        // }
      });
      candidateSetter();
    }, 700);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    debouncedGetCandidates(firstPage);

    return () => {
      debouncedGetCandidates.cancel();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, searchAndSortTypes, sort, listType]);

  useEffect(() => {
    const candidatesAfterLastCandidateSeeker = candidates.filter((candidate) => !seekerMap.get(candidate?.seeker as string));
    const newCandidates = candidatesAfterLastCandidateSeeker.map((candidate: CandidateSearchResponse['data'][0]) => {
      setSeekerMap((prev) => prev.set(candidate.seeker, true));
      return {
        candidate,
        key: candidate.id,
        label: candidate.fullName ?? `${candidate.firstName} ${candidate.lastName}`,
        type: NodeType.CANDIDATE,
        isFetching: false,
      };
    });
    setCandidatePresenterArray((prevState) => [...prevState, ...newCandidates]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginatedCandidates.lastSetDate]);

  const getCandidate = () => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    if (paginatedCandidates.lastFetchData?.length === 0) return;
    const page = paginatedCandidates.page + 1;
    searchCandidates({
      accountId: accountId!,
      filters: {
        listType,
        limit: PAGE_LIMIT,
        page,
        searchQuery,
        sortBy: sort === SeekerListSortType.ALPHABETICAL ? 'name' : 'createdAt',
        sortOrder: 'asc',
        advancedFilters: searchAndSortTypes,
      },
      ...(isPositionCandidatesPage() ? { positionId } : {}),
    });
  };

  useEffect(() => {
    if (!selectedCandidateId && candidatePresenterArray?.[0]?.key) {
      selectedCallback(candidatePresenterArray?.[0]?.candidate as Readonly<EngagedCandidate>);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidatePresenterArray?.[0]?.key, selectedCandidateId]);

  const treeCandidates = candidatePresenterArray;

  const isInitialLoading = paginatedCandidates.isFetching && paginatedCandidates.page < 1 && candidatePresenterArray.length === 0;

  useEffect(() => {
    const calculateHeight = () => {
      if (scrollableDivRef.current) {
        setListHeight(scrollableDivRef.current.offsetHeight);
      }
    };

    // Calculate height initially
    calculateHeight();

    // Recalculate height on window resize
    window.addEventListener('resize', calculateHeight);

    // Cleanup event listener
    return () => window.removeEventListener('resize', calculateHeight);
  }, []); //

  if (isInitialLoading)
    return (
      <Box marginY="auto" width="100%" textAlign="center">
        <Spinner color="#1F3CBA" data-testid="Spinner" />
      </Box>
    );
  return (
    <div
      style={{
        overflowX: 'hidden',
        height: 'calc(100vh - 200px)',
      }}
      ref={scrollableDivRef}
    >
      <InfiniteLoader
        isItemLoaded={() => paginatedCandidates.isFetching}
        itemCount={paginatedCandidates.total}
        loadMoreItems={getCandidate}
        threshold={PAGE_LIMIT}
      >
        {({ onItemsRendered, ref }) => (
          <FixedSizeList
            className="List"
            height={listHeight}
            width="100%"
            itemSize={80}
            ref={ref}
            itemCount={paginatedCandidates.total}
            onItemsRendered={onItemsRendered}
            overscanCount={20}
            itemData={{
              treeCandidates,
              isFetching: paginatedCandidates.isFetching,
              selectedCallback,
              allSeekerList,
              isShowFavoriteStatusEnabled,
            }}
          >
            {ItemRow}
          </FixedSizeList>
        )}
      </InfiniteLoader>
    </div>
  );
};

export default NewSeekerList;
